import {
  // Users,
  MapPin,
  Clock,
  DollarSign
} from 'lucide-react';

import { currencyFormat, formatMinutesToHours } from '@/helpers/stringHelpers';

import OfferingCategoryBadge from '@/app/offeringCategory/OfferingCategoryBadge';

import MeetingLocationMap from './MeetingLocationMap';

import { useOfferingObject } from '@/data/offering';
import { useActivityObject } from '@/data/activity';

const OfferingInfo = ({ offeringId }) => {
  const offering = useOfferingObject(offeringId);
  const activity = useActivityObject(offering.activityId);

  return (
    <div>
      <div className="flex items-center gap-4">
        <h1>{offering.name}</h1>
        <OfferingCategoryBadge offeringCategoryId={offering.categoryId} />
      </div>
      <span className="text-sm text-muted-foreground mb-4 block">
        {activity.title}
      </span>

      <div className="grid grid-cols-2 text-sm mb-4">
        <div className="space-y-1">
          <div className="flex items-center space-x-2">
            <Clock className="w-4 h-4 text-muted-foreground" />
            <span>{formatMinutesToHours(offering.length)} hours</span>
          </div>
          <div className="flex items-center space-x-2">
            <DollarSign className="w-4 h-4 text-muted-foreground" />
            <span>
              {currencyFormat(offering.subtotal).slice(1)} {offering.currency}{' '}
              /ea
            </span>
          </div>
        </div>
        <div className="space-y-1">
          {offering.location && (
            <div className="flex items-center space-x-2">
              <MapPin className="w-4 h-4 text-muted-foreground" />
              <span>{offering.location.name}</span>
            </div>
          )}
        </div>
      </div>
      <span className="text-sm text-muted-foreground block mb-4">
        {offering.description}
      </span>

      {offering.requirements && (
        <div className="mb-4">
          <h3 className="mb-2">Requirements</h3>
          <span className="text-sm text-muted-foreground block">
            {offering.requirements}
          </span>
        </div>
      )}

      {offering.includedItems && (
        <div className="mb-4">
          <h3 className="mb-2">Included</h3>
          <span className="text-sm text-muted-foreground block">
            {offering.includedItems}
          </span>
        </div>
      )}

      {offering.notIncludedItems && (
        <div className="mb-4">
          <h3 className="mb-2">Not Included</h3>
          <span className="text-sm text-muted-foreground block">
            {offering.notIncludedItems}
          </span>
        </div>
      )}

      {offering.isMeetingSpot && (
        <div>
          <h3 className="mb-2">Meeting Location</h3>
          <span className="font-bold block text-muted-foreground mb-2">
            {offering.locationName}
          </span>
          <div className="mb-2">
            <MeetingLocationMap
              lat={offering.meetingLat}
              lng={offering.meetingLng}
            />
          </div>
          <span className="font-bold block text-muted-foreground text-sm mb-4">
            {offering.locationDetails}
          </span>
        </div>
      )}
    </div>
  );
};

export default OfferingInfo;
